export const lightTheme = {
    body: '#ddebea',
    text: '#363537 !important',
    toggleBorder: '#FFF',
    background: '#363537',
    buttonBackground: '#fff',
    cardBackground: '#fff !important',
    postBackground: '#fff !important',
    menuBackground: '#fff !important',
    menuText: 'black !important',
    descriptionText: 'rgba(0,0,0,.4) !important'
}
export const darkTheme = {
    body: '#363537',
    text: '#FAFAFA !important',
    toggleBorder: '#6B8096',
    background: '#999',
    cardBackground: '#434244 !important',
    postBackground: '#363537 !important',
    menuBackground: '#434244 !important',
    buttonBackground: '#FAFAFA',
    menuText: '#fff !important',
    descriptionText: 'grey !important'
}